/**
 * PAPPO — Blocks service. Bloquear/desbloquear usuários (/api/blocks).
 * Bloqueio 1:1 e bidirecional; responsável↔filho nunca se bloqueiam (o backend recusa).
 */
import { apiDelete, apiGet, apiPost } from './api';

export interface BlockedUser {
  id: number;
  username: string;
  display_name: string;
  avatar_url: string | null;
}

/** Lista os usuários que EU bloqueei. */
export async function listBlocks() {
  return apiGet<{ blocked: BlockedUser[] }>('/blocks');
}

/** Bloqueia um usuário pelo id. */
export async function blockUser(targetId: number) {
  return apiPost('/blocks', { target_id: targetId });
}

/** Desbloqueia um usuário pelo id. */
export async function unblockUser(targetId: number) {
  return apiDelete(`/blocks/${targetId}`);
}
